import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { BasicUserUpdate } from "../interfaces/BasicUserUpdate";

interface Props {
  translations: {
    title: string;
    female: string;
    male: string;
    nonBinary: string;
  };
  defaultGender: string;
  setBasicUserData: (data: Partial<BasicUserUpdate>) => void;
  loading: boolean;
}

const useStyles = makeStyles((theme) => ({
  button: {
    marginBottom: "20px",
    color: theme.palette.text.primary,
    border: "2px solid #fee9ee",
    borderRadius: "12px",
    height: "52px",
    background: theme.palette.background.default,
    "&:hover": {
      border: "2px solid #FD9BB5",
      background: "#fee9ee",
    },
    "&.MuiButton-containedPrimary": {
      border: "2px solid #FD9BB5",
      background: "#fee9ee",
    },
  },
  middleButton: {
    paddingLeft: "4px",
    paddingRight: "4px",
  },
  leftButton: {
    paddingRight: "4px",
  },
  rightButton: {
    paddingLeft: "4px",
  },
  title: {
    marginBottom: "8px",
  },
}));

export const GenderInput: React.FC<Props> = (props) => {
  const { defaultGender, setBasicUserData, translations, loading } = props;
  const [genderSelection, setGenderSelection] = useState<string>(defaultGender);
  const classes = useStyles();

  useEffect(() => {
    if (genderSelection) {
      setBasicUserData({ gender: genderSelection });
    } else {
      setBasicUserData({ gender: null });
    }
  }, [genderSelection]);

  return (
    <Grid container direction="column">
      <Grid item xs={12}>
        <Typography variant="h6" className={classes.title}>
          {`${translations.title} *`}
        </Typography>
      </Grid>
      <Grid container direction="row">
        <Grid item xs={4} className={classes.leftButton}>
          <Button
            disabled={loading}
            className={classes.button}
            fullWidth
            color="primary"
            variant={genderSelection === "female" ? "contained" : "outlined"}
            onClick={() => setGenderSelection("female")}
          >
            {translations.female}
          </Button>
        </Grid>
        <Grid item xs={4} className={classes.middleButton}>
          <Button
            disabled={loading}
            className={classes.button}
            fullWidth
            color="primary"
            variant={genderSelection === "male" ? "contained" : "outlined"}
            onClick={() => setGenderSelection("male")}
          >
            {translations.male}
          </Button>
        </Grid>
        <Grid item xs={4} className={classes.rightButton}>
          <Button
            disabled={loading}
            className={classes.button}
            fullWidth
            color="primary"
            variant={genderSelection === "nonBinary" ? "contained" : "outlined"}
            onClick={() => setGenderSelection("nonBinary")}
          >
            {translations.nonBinary}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
